import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const root = css`
  display: flex;
  column-gap: ${spacing.base}px;
  border: 1px solid var(--functional-green-30);
  border-radius: 4px;
  padding: ${spacing.base}px ${spacing.xs}px;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveText.BODY.SM};
  color: var(--functional-green-base);
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;
